import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import FileUpload from "../../components/fileUpload";
import { handlePostRequest } from "../../services/PostTemplate";
import { toast } from "react-toastify";
import * as Yup from "yup";
import DownloadCSVFile from "./DownloadCSVFile";
import { handleGetRequest } from "../../services/GetTemplate";
import { useHistory } from "react-router-dom";
import DownloadExcelFile from "./DownloadExcelFile";

function AddCustomerBulkUpload() {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("pi pi-save");
  const [uploadFile, setUploadFile] = useState("");
  const [isRemoveFile, setIsRemoveFile] = useState(false);
  const [narrations, setNarrations] = useState([]);

  let history = useHistory();

  const validationSchema = Yup.object().shape({
    narration: Yup.mixed().required("This field is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      productId: "",
      parserId: "",
      narration: "",
    },
    onSubmit: async (data) => {
      if (!uploadFile) {
        toast.error("Please upload a file");
        return;
      }

      const fileExtension = uploadFile.name.split(".").pop();

      // Check if the file type is CSV
      // if (!uploadFile.name.endsWith(".csv")) {
      //   toast.error("Please upload a CSV file");
      //   return;
      // }

      try {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");

        const formData = new FormData();
        formData.append("multipartFile", uploadFile);
        formData.append("productId", "1");
        formData.append("narration", data?.narration);
        formData.append("fileName", uploadFile?.name);
        formData.append("fileType", fileExtension === "csv" ? "C" : "E");

        const res = await handlePostRequest(
          formData,
          "zbizgateway/customerFileUpload/productWiseBulkUpload"
        );
        console.log("res", res);

        formik.resetForm();
        onRemoveFile();
      } catch (error) {
        console.error("An error occurred:", error);
      } finally {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });

  const onRemoveFile = () => {
    setUploadFile("");
    setIsRemoveFile(true);
  };

  const handleFile = (files) => {
    setUploadFile(files);
  };

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const getNarrationsLov = async () => {
    setloading(true);
    try {
      const res = await handleGetRequest("zbizgateway/lov/lovNarration");
      setNarrations(res?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    getNarrationsLov();
  }, []);

  return (
    <>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">Add Customer Bulk Upload</h3>
          </div>
        </div>
      </div>
      <div className="card Card__Round">
        <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
          <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-4">
              <div className="p-field input_cp">
                <label
                  htmlFor="narration"
                  className={classNames(
                    { "p-error": isFormFieldValid("narration") },
                    "Label__Text"
                  )}
                >
                  Narration<span className="Label__Required">*</span>
                </label>
                <Dropdown
                  id="narration"
                  placeholder=""
                  options={narrations}
                  optionLabel="code"
                  optionValue="code"
                  name="narration"
                  value={formik.values.narration}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("narration") },
                    "Dropdown__Round"
                  )}
                />
                {getFormErrorMessage("narration")}
              </div>
            </div>
            <div className="p-field p-col-12 p-md-8">
              <div style={{ display: "flex", justifyContent: "end" }}>
                <div style={{ marginRight: "10px" }}>
                  <DownloadCSVFile />
                </div>
                <div>
                  <DownloadExcelFile />
                </div>
              </div>
            </div>
            <div className="p-field p-col-12 p-md-">
              <div className="p-field input_cp">
                <label
                  htmlFor="productId"
                  className={classNames(
                    { "p-error": isFormFieldValid("productId") },
                    "Label__Text"
                  )}
                >
                  File Upload
                </label>
                <FileUpload
                  handleFile={handleFile}
                  onRemoveFile={onRemoveFile}
                  isRemoveFile={isRemoveFile}
                />
              </div>
            </div>
          </div>

          <div className="GenerateDown__Btn p-mt-4">
            <Button
              disabled={loading}
              label="Add"
              className="Btn__Transparent"
            />
          </div>
        </form>
      </div>
    </>
  );
}

export default AddCustomerBulkUpload;
